export default "__VITE_ASSET__DnIdtD_E__"